import {
  Component,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
  OnChanges,
  SimpleChanges,
  TemplateRef,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  forwardRef,
} from "@angular/core";
import { debounceTime, Subject, Subscription } from "rxjs";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import DiacriticUtil from "../../utils/diacritic.util";
import { EventManagerService } from "../../service/event-manager.service";
declare let $;
@Component({
  selector: "dropdown",
  templateUrl: "./dropdown-search.component.html",
  styleUrls: ["./dropdown-search.component.scss"],
  providers: [
    {
       provide: NG_VALUE_ACCESSOR,
       useExisting: forwardRef(() => DropdownSearchComponent),
       multi: true
    }
 ]
})
export class DropdownSearchComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy
{
  @Input() title: string;
  @Input() list: any;
  @Input() disabled: any;
  @Input() isHaveContent = false;
  @Output() result: EventEmitter<any> = new EventEmitter();
  @Output() valueChange: EventEmitter<any> = new EventEmitter();
  @Output() valuesChange: EventEmitter<any> = new EventEmitter();
  @Output() resultGroup: EventEmitter<any> = new EventEmitter();
  @Output() emitSearch: EventEmitter<any> = new EventEmitter();
  @Output() firstClick: EventEmitter<any> = new EventEmitter();
  @Input() value: any = null;
  @Input() field: string = "name";
  @Input() key: string = "id";
  @Input() rowTemplate: TemplateRef<any>;
  @Input() name: any = "";
  @Input() multiple: any = false;
  @Input() isError: boolean = false;
  @Input() backgroundColor = "transparent";
  @Input() minWidth = "120px";
  @Input() minCharacter = 20;
  @Input() values: any[] = [];
  @Input() optionGroups: OptionGroup[] = [];
  @Input() isLong: boolean = false;
  @Input() tooMany: boolean = false;
  defaultItem: any = { id: undefined };
  @Input() isNoAll: any = true;
  @Input() isEmitSearch = false;
  isSelectAll: boolean = false;
  color: string = "";
  textSearch: string = "";
  valueShow: string = "";
  groups: any[] = [];
  openDropdownlist = false;
  isFirstClick: boolean = true;
  debouncSearch$ = new Subject();
  eventSubscribers?: Subscription[] = [];
  id =
    "myDropdown" +
    Math.floor(Math.random() * 1000) +
    Math.floor(Math.random() * 999);
  onChange: any = () => { };
  onTouched: any = () => { };
  constructor(private eventManager: EventManagerService, private cdf: ChangeDetectorRef) {}
  ngOnInit() {
    this.eventSubscribers = [
      this.eventManager.subscribe("selected-item", (res) => {
        if (res.content) {
          this.chooseValue(res.content);
        }
      }),
      this.eventManager.subscribe("body-click", (res) => {
        const event = res.content.event;
        if (
          $(event.target).closest("#" + this.id).length === 0 &&
          $(event.target).closest("#action" + this.id).length === 0
        ) {
          this.openDropdownlist = false;
          document.getElementById(this.id) &&
            document.getElementById(this.id).classList.remove("show");
        } else {
          this.openDropdownlist = true;
        }
      }),
      this.debouncSearch$.pipe(
        debounceTime(1000),
        ).subscribe((event)=> { return this.filter();}),
    ];
  }
  ngAfterViewInit() {
    $("select").click(function (e) {
      e.preventDefault();
    });
    this.cutName();
  }
  ngOnDestroy(): void {
    this.eventManager.destroys(this.eventSubscribers);
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.list && changes.list.currentValue) {
      this.onChangeList(changes.list.currentValue);
    }
    if (changes.value) {
      this.onChangeValue();
    }
    if (changes.values) {
      this.onChangeValues();
    }
    if (changes.optionGroups) {
      this.onChangeOptionGroup();
    }
    this.cutName();
  }
  onChangeList(currentValue) {
    this.list = JSON.parse(JSON.stringify(currentValue || []));
    if (this.value || this.value === 0) {
      this.onChangeValue();
    } else if (this.values) {
      this.onChangeValues();
    }
    if (this.optionGroups.length) {
      this.onChangeOptionGroup();
    }
    this.cutName();
  }
  onChangeValue() {
    if (!this.value && this.value !== 0) {
      this.name = this.title;
    }
    if ((this.value || this.value === 0) && this.list && this.list.length > 0) {
      const find =
        this.list.find(
          (item) =>
            item[this.key] === this.value ||
            item[this.key] === this.value[this.key] ||
            item[this.field] === this.value[this.field]
        ) || {};
      this.name = find[this.field];
      this.color = find.color || find.colorCode || this.color;
    }
  }
  onChangeValues() {
    this.list = this.list || [];
    if (!this.multiple || !this.list.length) {
      return;
    }
    this.values = this.values || [];
    if (!this.list.length) {
      this.name = this.values.map((item) => item[this.field]).join(", ");
      return;
    }
    const values = [];
    this.list.forEach((item) => {
      const isExist = this.values.find((value) => {
        return value[this.key] === item[this.key] || value === item[this.key];
      });
      if (isExist) {
        values.push(item);
      }
      item.isCheck = isExist ? true : false;
    });
    const removeItems = [];
    
    this.values.forEach((value) => {
      const index = this.list.findIndex((item) => {
        return value[this.key] === item[this.key] || value === item[this.key];
      });
      if (index === -1) {
        removeItems.push(index);
      }
    });
    removeItems.reverse();
    removeItems.forEach((index) => {
      this.values.splice(index, 1);
    });
    this.name = values.map((item) => item[this.field]).join(", ");
    if (values[0] !== this.values[0]) {
      this.result.emit(values);
    }
  }
  onChangeOptionGroup() {
    if (this.optionGroups.length > 0) {
      this.groups = [];
      this.optionGroups.forEach((option) => {
        const list =
          (this.list || []).filter((item) =>
            option.values.some((value) => value === item[option.field])
          ) || [];
        this.groups.push({
          option,
          list,
          isHide: !list.length
        });
      });
    }
  }
  cutName() {
    const defaultWidth = !$("#action" + this.id)[0]
      ? 200
      : $("#action" + this.id)[0].offsetWidth;
    const character =
      Math.floor(defaultWidth / (this.minCharacter * 7.5) - 0.1) *
      this.minCharacter; // 20 character = 150px
    this.name = this.name || "";
    this.name.length >= character && character > 0 ? (this.isLong = true) : this.isLong = false
    this.valueShow =
      this.name.length >= character && character > 0
        ? this.name.substring(0, character - 3) + "..."
        : this.name;
    this.cdf.detectChanges();
  }
  writeValue(currentValue: any): void {
    if (typeof currentValue === 'object') {
      this.values = currentValue;
      this.onChangeValues();
    } else {
      this.value = currentValue;
      this.onChangeValue();
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  open() {
    document.getElementById(this.id).classList.toggle("show");
    // document.getElementById('#backdrop').classList.toggle("show");
    $("#backdrop").toggleClass("show-backdrop");
    $("#backdrop").click(function (e) {
      $("#backdrop").removeClass("show-backdrop");
    });
  }
  debouncSearch() {
    this.debouncSearch$.next(true);
  }
  filter() {
    const filter = this.textSearch.toUpperCase();
    if (this.isEmitSearch) {
      this.emitSearch.emit(filter);
      return;
    } 
    if (!this.groups.length) {
      this.list.forEach((item) => {
        const text = (item[this.field] || "").toUpperCase();
        const text1 = DiacriticUtil.removeDiacritics(item[this.field] || "").toUpperCase();
        if (text.includes(filter) || text1.includes(filter) || !filter) {
          item.isHide = false;
        } else {
          item.isHide = true;
        }
      });
    } else {
      this.groups.forEach((group) => {
        group.isHide = true;
        group.list.forEach((item) => {
          const text = (item[this.field] || "").toUpperCase();
          const text1 = DiacriticUtil.removeDiacritics(item[this.field] || "").toUpperCase();
          if (text.includes(filter) || text1.includes(filter) || !filter) {
            group.isHide = false;
            item.isHide = false;
          } else {
            item.isHide = true;
          }
        });
      });
    }
    this.cdf.detectChanges();
  }
  chooseValue(value) {
    if (!this.multiple) {
      document.getElementById(this.id).classList.remove("show");
      this.value = value || {};
      this.name = this.value[this.field];
      this.color = this.value.color || this.value.colorCode  || this.color;
      this.valueChange.emit(value);
      this.result.emit(value);
      this.onChange(this.value[this.key]);
    } else {
      const firstValue = this.values[0];
      if (firstValue && !firstValue.id) {
        this.values = this.list.filter((item) => item.isCheck);
      }
      const index = this.values.findIndex(
        (item) => item[this.key] === value[this.key]
      );
      if (index === -1) {
        value.isCheck = true;
        if (!this.values.length && !value[this.key]) {
          this.isSelectAll = true;
          this.values = [value];
          this.list.forEach((item) => (item.isCheck = true));
        } else if (this.values.length && !value[this.key]) {
          this.isSelectAll = false;
          this.values = [];
          this.list.forEach((item) => (item.isCheck = false));
        } else if (value[this.key]) {
          this.values.push(value);
        }
      } else {
        value.isCheck = false;
        this.values.splice(index, 1);
      }
      this.name = this.values.map((item) => item[this.field]).join(", ");
      this.result.emit(this.values);
      this.valuesChange.emit(value);
      this.onChange(this.values);
    }
    this.cutName();
    $("#backdrop").removeClass("show-backdrop");
  }
  chooseGroup(group) {
    this.resultGroup.emit(group);
  }
  checkClick() {
    if (this.isFirstClick) {
      this.isFirstClick = false;
      this.firstClick.emit(true);
    }
  }
}
export class OptionGroup {
  field: string;
  values: any[];
  title: string;
  icon: string;
  constructor(params?) {
    if (!params) {
      return;
    }
    this.field = params.field;
    this.values = params.values;
    this.title = params.title;
    this.icon = params.icon;
  }
}
